var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teaching-evaluate-statistics"},[_c('PlatDataGridSemester',{attrs:{"grid-id":"PeTchEvaluationQuery","show-label":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }